import React from 'react';
import cn from 'classnames';
import { useRenderers } from '../../../../renderProps';
import Cell from './Cell/Cell';
import { useTheme } from '../../../../theme';
import { useTranslation } from 'react-i18next';
import SlickSlider from '../../../../SlickSlider';
const Content = ({ sliders, settings, compareTableGroups, isFullFareConditions }) => {
    const { t } = useTranslation('CompareFares');
    const { Content: css, FaresSlider: sliderCss } = useTheme('CompareFares');
    const { Cell: CellComponent = Cell } = useRenderers();
    return (React.createElement("div", { className: css.col }, compareTableGroups === null || compareTableGroups === void 0 ? void 0 : compareTableGroups.map(group => {
        return (React.createElement("div", { className: css.col, key: group.title },
            React.createElement("div", { className: css.groupTitle }, t(group.title)),
            group.rows.map(row => {
                var _a;
                return (React.createElement("div", { key: row.title, className: cn(css.tableRow, {
                        [css.tableRow_fullDescr]: isFullFareConditions
                    }) },
                    React.createElement("div", { className: cn(css.title, sliderCss.title) }, row.title),
                    React.createElement("div", { className: cn(css.slider, sliderCss.slider) },
                        React.createElement(SlickSlider, Object.assign({ ref: ref => sliders.push(ref) }, settings), (_a = row.cells) === null || _a === void 0 ? void 0 : _a.map((cell, index) => {
                            var _a;
                            return (React.createElement(CellComponent, { key: (_a = cell === null || cell === void 0 ? void 0 : cell.title) !== null && _a !== void 0 ? _a : index, cell: cell, isFullFareCondition: isFullFareConditions }));
                        })))));
            })));
    })));
};
export default Content;
